module.exports = __webpack_public_path__ + "400221ac902d02a02db2433d955c2f83.svg";